import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';

import LoginPage from './pages/LoginPage';
import { fetchDictionaties } from './redux/catalogSlice';
import { checkAuth } from './redux/authSlice';

import './custom.css';

const App = () => {
    const dispatch = useDispatch();
    const { isAuth } = useSelector(state => state.auth);

    //опдгрузим справочную систему при запуске SPA

    useEffect(() => {
        if (isAuth) {
            dispatch(fetchDictionaties());
        };
    }, [isAuth, dispatch]);

    return (
        <Layout>
            {!isAuth ? 
                <LoginPage />
            :
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={element} />;
                    })}
                </Routes>
            }
        </Layout>
    );
}

export default App;

